import {
  TABLE_BOOKING_CLUB_BOOKINGS,
  TABLE_BOOKING_CLUB_LAYOUT,
  TABLE_BOOKING_CLUB_LAYOUTS,
  TABLE_BOOKING_MANAGER_TABLE_SHEET_SHARE_LINK,
  TABLE_BOOKING_PUBLIC_TABLE_SHEET,
} from "./endPoint";
import instance from "../helpers/axios";
import guestAxios from "../helpers/guestAxios";

export const fetchTableBookingLayouts = (clubId) =>
  instance.get(TABLE_BOOKING_CLUB_LAYOUTS(clubId));

export const fetchTableBookingLayout = (clubId, layoutId) =>
  instance.get(TABLE_BOOKING_CLUB_LAYOUT(clubId, layoutId));

export const createTableBookingLayout = (clubId, body) =>
  instance.post(TABLE_BOOKING_CLUB_LAYOUTS(clubId), body);

export const updateTableBookingLayout = (clubId, layoutId, body) =>
  instance.put(TABLE_BOOKING_CLUB_LAYOUT(clubId, layoutId), body);

export const deleteTableBookingLayout = (clubId, layoutId) =>
  instance.delete(TABLE_BOOKING_CLUB_LAYOUT(clubId, layoutId));

export const fetchTableBookingBookings = (clubId, params = {}) =>
  instance.get(TABLE_BOOKING_CLUB_BOOKINGS(clubId), { params });

/** Public live table sheet — no Authorization header. */
export const fetchPublicTableSheet = (slug, params = {}) =>
  guestAxios.get(TABLE_BOOKING_PUBLIC_TABLE_SHEET(String(slug).toLowerCase()), {
    params,
  });

/** Manager share link for public table sheet page. */
export const fetchTableSheetShareLink = (clubId) =>
  instance.get(TABLE_BOOKING_MANAGER_TABLE_SHEET_SHARE_LINK(clubId));
